import Page from './index';
export default {
settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
	},
	// auth: authRoles.user,
	routes: [
		{
			path: '/payment-terms',
			exact: true,
			component: Page.Layout
		},
		// {
		// 	path: '/subscription-payment-terms',
		// 	exact: true,
		// 	component: Page.Layout
		// },
	]
};